import PropTypes from 'prop-types'

export const channel = '__EMOTION_THEMING__'

export const contextTypes = {
  [channel]: PropTypes.object
}
